module.exports = function (app) {
    "use strict";
    app.controller('pages.clientInfo', ["$state", "$scope", "sessionData", "services", "$timeout", "employerUtility", "idTheftDisclaimer",
        "modal", "coremetrics",
        function ($state, $scope, sessionData, services, $timeout, employerUtility, idTheftDisclaimer, modal, coremetrics) {

            if ((sessionData.entitlements.clientStatus.cancelled == true)
                && (!sessionData.cancelledClientHasAgreed)) {
                $state.go('cancelledConditions');
            }

        // Sidebar
        $scope.sidebar = {
            breadCrumb: {
                primary: {
                    title: ''
                }
            },
            links: [
                {
                    heading: "General Information",
                    label: "General Information",
                    state: "clientInfo.generalInfo",
                    description: "General Information"
                }, {
                    heading: "Contacts",
                    label: "Client Contacts",
                    state: "clientInfo.contacts",
                    description: "Client Contacts"
                }
            ]
        };
        var isCancelled = (sessionData.employerInfo.clientStatus == 'CANCELLED_ACCESS') ||
            (sessionData.employerInfo.clientStatus == 'NO_ACCESS');
        if(sessionData.entitlements.idTheft && !isCancelled){
            $scope.sidebar.links.push({
                heading: "ID Theft Protection",
                label: "ID Theft Protections",
                // state: "employee.account.protection",
                state: 'clientInfo.idTheft',
                description: "ID Theft Protection"
            });
        }

        $scope.pageTitle="Client Contacts";
        $scope.disableDrawers=true;
        $scope.contactSections = [];
        $scope.generalInfoSections = [];
        // Coremetrics -------------------------------------------------==

        $scope.reportCodes =
        {
            expand: true,
            disableSort: true,
            pagination: {
                itemsPerPage: 1000,
                page: 1
            },
            titles: [
                {
                    name: "Type",
                    dataKey: "type",
                    selectAll: true
                },
                {
                    name: "Code",
                    dataKey: "strCodes",
                    selectAll: true
                },
                {
                    name: "Associated Groups",
                    dataKey: "groups",
                    selectAll: true
                }
            ],
            rows: [
            ]
        }

            $scope.tableData = {
                orderBy: "lastUpdated",
                reverse: true,
                titles: [
                    {
                        name: "Group Number",
                        dataKey: "groupNumber"
                    },
                    {
                        name: "Group Name",
                        dataKey: "displayName"
                    },
                    {
                        name: "Vendor",
                        dataKey: "optDescription"
                    },
                    {
                        name: "Protection Start",
                        dataKey: "contractBeginDate"
                    },
                    {
                        name: "Protection End",
                        dataKey: "contractEndDate"
                    },
                    {
                        name: "All Opt in",
                        dataKey: "protectionEnabled",
                        selectAll: true,
                        selectAllValue: "true"
                    },
                    {
                        name: "All Opt out",
                        dataKey: "protectionEnabled",
                        selectAll: true,
                        selectAllValue: "false"
                    }
                ],
                selectAll: function(propertyName){
                    var propVal = '';

                    for(var i = 0; i < $scope.tableData.titles.length; i++){
                        if($scope.tableData.titles[i].name == propertyName){
                            propVal = $scope.tableData.titles[i].selectAllValue;
                            break;
                        } }
                    propVal = (propVal == 'true') ? true : false;
                    for (var j=0; j<$scope.tableData.data.length; j++) {
                        if(!$scope.tableData.data[j].disabled){
                            $scope.tableData.data[j]['protectionEnabled'] = propVal;
                        }
                    } } };

        $scope.feedback = {};
        $scope.serviceReturnedItems = false;
        $scope.sidebar.breadCrumb.primary.title = sessionData.employerInfo.planAdministrator.company;
        $scope.brand = sessionData.employerInfo.brandName;

            var displayMessageInCorrectContainer = function(theMsg, isModal) {
                // we dont count characters here to decide whether to pop a modal or not
                // because we want PAs from all brands to have the same Success message format, and
                // IBCs message is short
                if (isModal) {
                    var modalScope = $scope.$new();
                    modalScope.theMsg = theMsg;
                    modal.open({
                        template: require('modals/idTheftFeedback.html'),
                        scope: modalScope
                    });
                } else {
                    $scope.feedback.showFeedback(theMsg, 'notification');
                }
            }
            var isIbcOrAhnj = (sessionData.employerInfo.brandName == '6008' || sessionData.employerInfo.brandName == '6009') ? true : false;

            var showMessageInUi= function(msgCase) {
            var msgText;
            var isModal = false;
            switch (msgCase) {
                case 'getIdTheftSvcFailed':
                    msgText = isIbcOrAhnj ? 'This Page is currently unavailable. Please contact Customer Service for immediate assistance.'
                                          : 'This Page is currently unavailable. Please contact your Client Manager for immediate assistance.';
                    break;
                case 'saveIdTheftSvcFailed':
                    msgText = isIbcOrAhnj ? 'The system failed to update your selection. Please try again. Should issues persist, please contact Customer Service.'
                                          : 'The system failed to update your selection. Please try again. Should issues persist, please contact your Client Manager.';
                    break;
                case 'saveIdTheftChangesSuccessful':
                    isModal = true;
                    msgText = isIbcOrAhnj ? 'Your request has been processed successfully.'
                                          : 'You have successfully opted in to identity protection services. Thank you for choosing to protect your most important asset, your employees. <br /><br /> If you have any questions, or you did not submit this form, please contact your Client Manager';
                    break;
                case 'noGroupsWereChanged':
                    msgText = isIbcOrAhnj ? 'Please make sure that you have made your selection prior to submission. Should issues persist, please contact Customer Service.'
                                          : 'Please make sure that you have made your selection prior to submission. Should issues persist, please contact your Client Manager.';
                    break;
                default:
                    msgText = 'We did not get a msgCase we recognized.';
                    break;
            }
                displayMessageInCorrectContainer(msgText, isModal);
                window.scrollTo(0,0);
        }

        var groupData = '';
        var handleServiceSuccess = function(retObj, theCaller) {
        if (retObj && retObj.data && retObj.data.payload && retObj.data.payload) {
            $scope.serviceReturnedItems = true;
            var thePayload =  retObj.data.payload;
            switch (theCaller) {
                case 'GenInfoSvc':
                    // NOTE: this data displays in general-info.html w the details in general-info-detail.html
                    coremetrics.pageviewTag('EMPLOYERS:CLIENT GROUPS:CLIENT GENERAL INFORMATION', 'EMPLOYERS:CLIENT GROUPS');
                    $scope.genInfoServiceCallIsRunning = false;
                    thePayload.name =  "Client General Information";
                    thePayload.expand = true;
                    thePayload.hasItems = true;
                thePayload.src = 'client-info/general-info.employerTemplate.html/pages/clientAndGroup/general-info-detail';
                    $scope.generalInfoSections.push(thePayload);
                    $scope.sidebar.breadCrumb.primary.subTitle =  "(" + $scope.generalInfoSections[0].status + ")";
                    break;
                case 'ReportCodesSvc':
                    // NOTE: this data displays in general-info.html w the details in general-info-detail.html
                    $scope.reportCodeServiceCallIsRunning = false;
                    $scope.reportCodes.hasItems = true;
                    $scope.reportCodes.name =  "Report Codes";
                    $scope.reportCodes.src = 'client-info/general-info.employerTemplate.html/pages/clientAndGroup/reports';
                    employerUtility.makeGroupsArrayIntoAString(thePayload);
                    $scope.reportCodes.rows = thePayload;
                    $scope.generalInfoSections.push($scope.reportCodes);
                    break;
                case 'ContactsSvc':
                    // NOTE: this data displays in general-info.html w the details in contacts.html
                    $scope.thirdServiceCallIsRunning = false;
                    thePayload.hasItems = true;
                    $scope.contactSections = thePayload;
                    break;
                case 'IdTheft':
                    $scope.idTheftServiceCallIsRunning = false;
                    $scope.theftGroupsWereReturned = true;
                    thePayload.hasItems = true;
                    $scope.tableData.data = [];

                    groupData = thePayload;
                    $scope.tableData.data = angular.copy(groupData);
                    break;
                default:
                    alert('This is an unexpected caller.')
                    break;
            }

            } else {
            $scope.genInfoServiceCallIsRunning = false;
            $scope.reportCodeServiceCallIsRunning = false;
            $scope.thirdServiceCallIsRunning = false;
            $scope.idTheftServiceCallIsRunning = false;
            alert("The service returned something unexpected.", "failure");
        }
        }
        var handleServiceFailure = function(err, theCaller) {
            $scope.genInfoServiceCallIsRunning = (theCaller == 'GenInfoSvc') ? false : $scope.genInfoServiceCallIsRunning;
            $scope.reportCodeServiceCallIsRunning = (theCaller == 'ReportCodesSvc') ? false : $scope.reportCodeServiceCallIsRunning;
            $scope.thirdServiceCallIsRunning =  (theCaller == 'ContactsSvc') ? false : $scope.thirdServiceCallIsRunning;
            $scope.idTheftServiceCallIsRunning =  (theCaller == 'IdTheft') ? false : $scope.idTheftServiceCallIsRunning;
            // if $scope.tableData.data already has data we are refreshing the ID Theft data from the service
            // which is what we do on save.  We are not leaving the page at that point.
            if ($scope.tableData && $scope.tableData.data && $scope.tableData.data.length && $scope.tableData.data.length > 0) {
                $scope.tableData.data = [];
            }
            if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
                console.error(err.data.baseMessage.returnCodeDescription);
                console.error('No items found for service = ' + theCaller);
            } else {
                console.error('Non-standard error for ' + theCaller+ ' service.');
                console.error(err);
            }
            if (theCaller == 'IdTheft') {
                showMessageInUi('getIdTheftSvcFailed');
            }
        }
        var originalSvcPayload = [];
        $scope.genInfoServiceCallIsRunning = false;
        $scope.reportCodeServiceCallIsRunning = false;
        $scope.thirdServiceCallIsRunning = false;
        $scope.idTheftServiceCallIsRunning = false;
        $scope.theftGroupsWereReturned = false;
        //var arrIdTheftSvcResponsePayload = [];
            var getItemsFromService = function(theCaller) {
            if (theCaller =='GenInfoSvc') {
                $scope.genInfoServiceCallIsRunning = true;
                services.eprsvc.clientInformation().getGeneralInfo().then(function (retObj) {
                    handleServiceSuccess(retObj, 'GenInfoSvc');
                }, function (err) {
                    handleServiceFailure(err, 'GenInfoSvc');
                });
            } else if (theCaller =='ReportCodesSvc') {
                $scope.reportCodeServiceCallIsRunning = true;
                services.eprsvc.clientInformation().getReportCodes().then(function (retObj) {
                    handleServiceSuccess(retObj, 'ReportCodesSvc');
                }, function (err) {
                    handleServiceFailure(err, 'ReportCodesSvc');
                });
            } else if (theCaller =='ContactsSvc') {
                $scope.thirdServiceCallIsRunning = true;
                services.eprsvc.clientInformation().getContacts().then(function (retObj) {
                    handleServiceSuccess(retObj, 'ContactsSvc');
                }, function (err) {
                    handleServiceFailure(err, 'ContactsSvc');
                });
            } else if (theCaller =='IdTheft') {
                $scope.idTheftServiceCallIsRunning = true;
				services.eprsvc.idTheft().getGroups().then(function (retObj) {
					angular.copy(retObj.data.payload, originalSvcPayload);
					handleServiceSuccess(retObj, 'IdTheft');
				}, function (err) {
					$scope.theftGroupsWereReturned = false;
					handleServiceFailure(err, 'IdTheft');
				});
            } else {
                alert('We don\'t expect to be on this page.')
            }
        }

        $scope.$watch(function(){
            return $state.$current.name
        }, function(newVal, oldVal){
            if (newVal == 'clientInfo.contacts') {
                coremetrics.pageviewTag('EMPLOYERS:CLIENT GROUPS:CLIENT CONTACTS', 'EMPLOYERS:CLIENT GROUPS');
            }
            if (newVal == 'clientInfo.idTheft') {
                // we hit the idTheft service only when the PA hits that tab
                if(sessionData.entitlements.idTheft && !isCancelled && ($state.current.name == 'clientInfo.idTheft')){
                    setTimeout(function() {
                        $scope.feedback.hideFeedback();
                    }, 1000);
                    getItemsFromService('IdTheft');
                } } });
        // HIT INITIAL SERVICES ===============================================================
        getItemsFromService('GenInfoSvc');
        $timeout(function () {
            getItemsFromService('ReportCodesSvc');
        }, 100);
        $timeout(function () {
            getItemsFromService('ContactsSvc');
        }, 100);
        $scope.collapseAllRows=function(){
            $scope.expandList=false;
                for(var i=0;i<$scope.generalInfoSections.length;i++){
                    $scope.generalInfoSections[i].expand=false;
                }
        };
        $scope.checkExpand=function(){
            var allExpanded=true;
            for(var i=0;i<$scope.generalInfoSections.length;i++){
                if(!$scope.generalInfoSections[i].expand){
                    allExpanded=false;
                    break;
                }
            }
            $scope.expandList=allExpanded;
        };
        $scope.expandCollapseAllRows=function(){
            $scope.expandList=!$scope.expandList;
            for(var i=0;i<$scope.generalInfoSections.length;i++){
                $scope.generalInfoSections[i].expand=$scope.expandList;
            }

        };
        // ============= BEGIN ID THEFT CODE ==============================================
            $scope.disclaimer = idTheftDisclaimer;
            $scope.filterData = {
                'groupStatus': '',
                'groupNumber': ''
            };
            $scope.filterNumber = function(otherFilter){
                var groupDataFilter = [];
                var groupDataCopy;
                if(otherFilter){
                    groupDataCopy = otherFilter;
                }else{
                    groupDataCopy = groupData;
                }
                angular.forEach(groupDataCopy, function(group) {
                    if (group.groupNumber.search($scope.filterData.groupNumber) > -1) {
                        groupDataFilter.push(group);
                    }
                });
                $scope.tableData.data = groupDataFilter;
                if(!otherFilter){
                    $scope.filterStatus($scope.groupDataShow);
                }
            };
            $scope.filterStatus = function(otherFilter){
                var groupDataFilter = [];
                var groupDataCopy;
                if(otherFilter){
                    groupDataCopy = otherFilter;
                }else{
                    groupDataCopy = groupData;
                }
                if($scope.filterData.groupStatus == ''){
                    groupDataFilter = groupDataCopy;
                }else{
                    angular.forEach(groupDataCopy, function(group){
                        if($scope.filterData.groupStatus == 'active' && group.status){
                            groupDataFilter.push(group);
                        }
                        else if($scope.filterData.groupStatus == 'inactive' && !group.status){
                            groupDataFilter.push(group);
                        }
                    });  }
                $scope.tableData.data = groupDataFilter;
                if(!otherFilter){
                    $scope.filterNumber($scope.tableData.data);
                }  };

            var generatePayload = function(){
                var svcPayload = {
                    "payload": {
                        "idTheftGroups": []
                    } };
                // make an array of only the objects whose protectionEnabled property has changed
                var arrChangedObjects = [];
                var tableDataGroups = $scope.tableData.data;
                for (var i=0; i < tableDataGroups.length; i++) {
                    for (var j=0; j < originalSvcPayload.length; j++) {
                        if ((tableDataGroups[i].groupNumber == originalSvcPayload[j].groupNumber) &&
                            (tableDataGroups[i].protectionEnabled != originalSvcPayload[j].protectionEnabled)
                        ) {
                            arrChangedObjects.push(tableDataGroups[i]);
                        } } }
                // make object with "optin" and "optout" as needed by the svc
                angular.forEach(arrChangedObjects, function(group){
                    var userChoice = (group.protectionEnabled ? 'optin' : 'optout');
                    var groupObj = {
                        groupNumber: group.groupNumber,
                        userChoice: userChoice
                    };
                    svcPayload.payload.idTheftGroups.push(groupObj);
                });
                return svcPayload;
            };

            $scope.save = function(){
                $scope.feedback.hideFeedback();
                // we create an array to send to the server that ONLY has items the user changed
                var payload = generatePayload();
                if (payload.payload.idTheftGroups.length == 0) {
                    showMessageInUi('noGroupsWereChanged')
                    return;
                }
                services.eprsvc.idTheft().save(payload).then(function(response){
                    if (response && response.status && response.status == 200) {
                        showMessageInUi('saveIdTheftChangesSuccessful')
                        getItemsFromService('IdTheft');
                    } else {
                        showMessageInUi('saveIdTheftSvcFailed');
                    }
                    window.scrollTo(0,0);
                },function(error){
                    showMessageInUi('saveIdTheftSvcFailed');
                    window.scrollTo(0,0);
                })
            }

            // ============= END ID THEFT CODE =========================================
        }]);
    return [
        {
            state: "clientInfo",
            url: "/client-info",
            abstract: true,
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page-side-bar.html'],
                    controller: "pages.clientInfo"
                }
            }
        },
        {
            state: "clientInfo.contacts",
            url: "/contacts",
            postPassword: true,
            views: {
                "content@clientInfo": {
                    templateUrl: "client-info/contacts.employerTemplate.html/pages/clientAndGroup/contacts"
                }
            }
        },
        {
            state: "clientInfo.generalInfo",
            url: "/general-info",
            postPassword: true,
            views: {
                "content@clientInfo": {
                    templateUrl: "client-info/general-info.employerTemplate.html/pages/clientAndGroup/general-info"
                }
            }
        },
        {
            state: "clientInfo.idTheft",
            url: "/id-theft",
            postPassword: true,
            views: {
                "content@clientInfo": {
                    templateUrl: "client-info/id-theft.employerTemplate.html/pages/clientAndGroup/id-theft"
                }
            }
        }
    ];
};
